export const locale = {
  lang: 'en',
  data: {
    guards: {
      notSupportedDevice: {
        message: `The device you are using is not supported to complete the form. Please use a tab, laptop or workstation.`,
        title: 'Warning'
      }
    }
  }
};
